import mitt from 'mitt';

const KEY_RECREATE_WECHAT_LOGIN = 'KEY_RECREATE_WECHAT_LOGIN';
const KEY_MARKDOWN_RUN_CODE = 'KEY_MARKDOWN_RUN_CODE';
const KEY_MARKDOWN_RUN_CODE_RESPONSE = 'KEY_MARKDOWN_RUN_CODE_RESPONSE';

interface RunCodeParam {
  id: string;
  code: string;
}

type Events = {
  [KEY_RECREATE_WECHAT_LOGIN]: undefined;
  [KEY_MARKDOWN_RUN_CODE]: RunCodeParam;
};

// 虽然事件总线很好用
// 但是建议只用于全局事件通信，而非组件间通信
// 比如全局定时任务触发的事件或者websocket接收到特定消息触发的事件
export const EventBus = mitt<Events>();

// 用于更新微信登录二维码的刷新
export function recreateWechatLogin() {
  EventBus.emit(KEY_RECREATE_WECHAT_LOGIN);
}
// 需要挂在window上，用于iframe之间的调用
window.recreateWechatLogin = recreateWechatLogin;
export function recreateWechatLoginOn(fn: any) {
  EventBus.on(KEY_RECREATE_WECHAT_LOGIN, fn);
}
export function recreateWechatLoginOff() {
  EventBus.off(KEY_RECREATE_WECHAT_LOGIN);
}

// 用于markdown和运行代码之间的通信
export function runMarkdownCode(data: RunCodeParam) {
  EventBus.emit(KEY_MARKDOWN_RUN_CODE, data);
}
export function runMarkdownCodeOn(fn: (data: RunCodeParam) => void) {
  EventBus.on(KEY_MARKDOWN_RUN_CODE, fn);
}
export function runMarkdownCodeOff() {
  EventBus.off(KEY_MARKDOWN_RUN_CODE);
}
// 返回运行代码的结果：成功/失败
function getResponseKey(id: string) {
  return `${KEY_MARKDOWN_RUN_CODE_RESPONSE}_${id}` as any;
}
export function runMarkdownCodeResponse(id: string, result: boolean) {
  EventBus.emit(getResponseKey(id), result);
}
export function runMarkdownCodeResponseOn(
  id: string,
  fn: (result: boolean) => void,
) {
  EventBus.on(getResponseKey(id), fn);
}
export function runMarkdownCodeResponseOff(id: string) {
  EventBus.off(getResponseKey(id));
}
